module.exports = __webpack_public_path__ + "img/about_m.fcea0954.png";